import { jsx as _jsx } from "react/jsx-runtime";
import Rive, { RuntimeLoader } from '@rive-app/react-canvas-lite';
import { animationMap, animationSizeMap } from './constants';
export const Animation = ({ name, size: passedSize = 'medium', }) => {
    const src = animationMap[name];
    const size = animationSizeMap[passedSize];
    const style = {
        width: size,
        height: size,
    };
    return (_jsx(Rive
    // Without the key doesn't reload after src change
    , { src: src, style: style }, name));
};
export const RiveRuntimeLoader = RuntimeLoader;
